import React from "react";
import { FaCheck } from "react-icons/fa";

const UserTopics = () => {
  return (
    <div className="bg-gray-100 py-10">
      <div className="font-josefin-sans max-w-3xl mx-auto px-4">
        <p className="text-2xl md:text-4xl py-2 px-4 text-center mb-6">
          We are working on providing conceptual, technical and practical solutions in science,
          technology, engineering, and mathematics at the higher education
          level.
        </p>
        <h2 className="text-2xl font-bold mb-6">
          The current categories and their respective topics are listed below:
        </h2>
        <ul className="list-disc pl-6 text-xl mb-6">
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            Web Development:
          </li>
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            Android Development:
          </li>
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            Data Science:
          </li>
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            Gate (MA):
          </li>
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            NET-JRF (MA):
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UserTopics;
